import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { TopMenu } from "./components/TopMenu/TopMenu";
import { UploadCardsPage } from "./pages/UploadCardsPage/UploadCardsPage";
import { MyInventoryPage } from "./pages/MyInventoryPage/MyInventoryPage";
import { PriceStrategyPage } from "./pages/PriceStrategyPage/PriceStrategyPage";
import { Toaster } from "react-hot-toast";
import TransactionPage from "./pages/TransactionsPage/TransactionPage";
import { AuthProtected } from "./guards/AuthGuard";
import { LoginPage } from "./pages/LoginPage/LoginPage";
import { UserData } from "./hoc/UserData";
import { SanityCheckPage } from "./pages/SanityCheckPage/SanityCheckPage";

function AppContent() {
  const location = useLocation();

  // Determine if we are on the login page
  const isLoginPage = location.pathname === "/";

  return (
    <>
      <UserData />
      <Toaster
        toastOptions={{
          style: { zIndex: 20000 },
        }}
      />
      {!isLoginPage && <TopMenu />}

      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route
          path="/upload-cards"
          element={
            <AuthProtected>
              <UploadCardsPage />
            </AuthProtected>
          }
        />
        <Route
          path="/inventory"
          element={
            <AuthProtected>
              <MyInventoryPage />
            </AuthProtected>
          }
        />
        <Route
          path="/pricing"
          element={
            <AuthProtected>
              <PriceStrategyPage />
            </AuthProtected>
          }
        />
        <Route
          path="/transaction"
          element={
            <AuthProtected>
              <TransactionPage />
            </AuthProtected>
          }
        />
        <Route
          path="/sanity-check"
          element={
            <AuthProtected>
              <SanityCheckPage />
            </AuthProtected>
          }
        />
        <Route path="*" element={<div>404 - Not Found</div>} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
